import { combineReducers } from "redux";
import csrf from "./csrf.reducer";

export default combineReducers({
    csrf,
})